import useUiuxStore from "src/store/useUiuxStore";
import { showWarning } from "src/utils/toast/toastUtil";
import { validateItemAccount, restoreOriginalValues } from "../Util_MST3040_R01";
import { MST3040_R01DetailDto } from "../Dto_MST3040_R01";

interface UseBomModalProps {
	updateMST3040_R01Detail: (index: number, data: MST3040_R01DetailDto) => void;
	gridRef: any;
	MST3040_R01DetailList: MST3040_R01DetailDto[];
}

export function useCoordinateModal({ updateMST3040_R01Detail, gridRef, MST3040_R01DetailList }: UseBomModalProps) {
	const { setCodeSearchModalProps } = useUiuxStore();

	const handlePopupClose = () => {
		if (gridRef.current?.api) {
			gridRef.current.api.stopEditing();
		}
	};

	const settingCodeSearchModalProps = (
		category: string,
		search: string,
		isInfo: boolean,
		handleFoucsId: string,
		originalData: MST3040_R01DetailDto,
		valueIndex: number,
		extraFilter?: Record<string, string>,
	) => {
		const handleClear = () => {
			const updateData: Partial<MST3040_R01DetailDto> = {
				...originalData,
				isModified: originalData.inserted ? false : true,
			};

			if (handleFoucsId === 'childItemcd') {
				updateData.childItemcd = '';
				updateData.childItemnm = '';
				updateData.itemSpec = '';
				updateData.locationCd = '';
				updateData.locationNm = '';
			} else if (handleFoucsId === 'afeederCd') {
				updateData.afeederCd = '';
			} else if (handleFoucsId === 'bfeederCd') {
				updateData.bfeederCd = '';
			} else if (handleFoucsId === 'cfeederCd') {
				updateData.cfeederCd = '';
			}

			updateMST3040_R01Detail(valueIndex, updateData as MST3040_R01DetailDto);
			handlePopupClose();
		};

		setCodeSearchModalProps({
			category,
			search,
			formName: 'MST3040_R01',
			isInfo,
			handleFoucsId,
			onClear: handleClear,
			onConfirm: (data: any) => {
				const updateData: Partial<MST3040_R01DetailDto> = {
					...originalData,
					isModified: originalData.inserted ? false : true,
				};

				if (handleFoucsId === 'childItemcd') {
					updateData.childItemcd = data.childItemcd || '';
					updateData.childItemnm = data.itemNm || '';
					updateData.itemSpec = data.itemSpec || '';
					updateData.locationCd = data.locationCd || '';
					updateData.locationNm = data.locationNm || '';

					if (data.itemAccount && !validateItemAccount(data.itemAccount)) {
						showWarning(
							`선택한 품목(${data.itemNm})은 BOM 등록이 불가능한 계정입니다.\n허용 품목 계정: 재공품, 원자재, 부자재`,
							5000
						);
						restoreOriginalValues(valueIndex, originalData, updateMST3040_R01Detail, gridRef);
						return;
					}
				} else if (handleFoucsId === 'afeederCd') {
					updateData.afeederCd = data.minorCd || '';
				} else if (handleFoucsId === 'bfeederCd') {
					updateData.bfeederCd = data.minorCd || '';
				} else if (handleFoucsId === 'cfeederCd') {
					updateData.cfeederCd = data.minorCd || '';
				}

				const currentRow = MST3040_R01DetailList.find(item => item.valueIndex === valueIndex);
				if (currentRow && data) {
					updateMST3040_R01Detail(valueIndex, {
						...currentRow,
						...updateData,
						isModified: true
					});
				}
				setTimeout(() => {
					const api = gridRef.current?.api;
					if (!api) return;
				}, 0);
			},
			wrapperOption: {
				size: 'md',
				width: 50,
				overlay: true
			},
			...((category === 'BOM_자품목' || extraFilter) && {
				extraFilter: {
					...(category === 'BOM_자품목' ? { prntItemcd: originalData.prntItemcd || '' } : {}),
					...(extraFilter || {}),
				},
			}),
		});
	};

	return { settingCodeSearchModalProps, handlePopupClose };
}
